import { serverAddr } from "../networkConfig";

export default {
	getAllOutlet() {
		return serverAddr.get("/outlet/?get_all=true");
	},
	createOutlet(params) {
		return serverAddr.post("/outlet/", params);
	},
	editOutlet(outletId, params) {
		return serverAddr.patch(`/outlet/${outletId}/`, params);
	},
	editRegion(outletId, params) {
		return serverAddr.patch(`/outlet/region/${outletId}/`, params);
	},
	editSubRegion(outletId, params) {
		return serverAddr.patch(`/outlet/subregion/${outletId}/`, params);
	},
	createCountry(params) {
		return serverAddr.post("/outlet/country/", params);
	},
	createCity(params) {
		return serverAddr.post("/outlet/city/", params);
	},
	createRegion(params) {
		return serverAddr.post("/outlet/region/", params);
	},
	createSubregion(params) {
		return serverAddr.post("/outlet/subregion/", params);
	},
	createAccount(params) {
		return serverAddr.post("/users/create-update/", params);
	},
	getOutletWithUserDetails(params, pageInfo) {
		// console.log("pageInfo", pageInfo, "params", params);
		return serverAddr.get(
			`/outlet/with-users/?page=${pageInfo.currentPage}&page_size=${
				pageInfo.pageSize
			}`,
			params
		);
	},
	getOutletWithRegionUserDetails(params, pageInfo) {
		// console.log("pageInfo", pageInfo, "params", params);
		return serverAddr.get(`/outlet/region/${params}/users/`);
	},
	getOutletWithSubRegionUserDetails(params, pageInfo) {
		// console.log("pageInfo", pageInfo, "params", params);
		return serverAddr.get(`/outlet/subregion/${params}/users/`);
	},
	viewUserPermissions(pageInfo) {
		return serverAddr.get(
			`/users/permissions/?page=${pageInfo.currentPage}&page_size=${
				pageInfo.pageSize
			}&search=${pageInfo.search}`
		);
	},
	setUserPermissions(params) {
		return serverAddr.post("/users/set-permissions/", params);
	},
	getOutlet(outlet) {
		return serverAddr.get(`/outlet/${outlet}/`);
	},
	getRegionOutlet(outlet) {
		return serverAddr.get(`/outlet/region/${outlet}/`);
	},
	getAllRegion() {
		return serverAddr.get(`/outlet/region/?get_all=true`);
	},
	getAllSubRegion() {
		return serverAddr.get(`outlet/subregion/?get_all=true`);
	},
	getSubRegionOutlet(outlet) {
		return serverAddr.get(`/outlet/subregion/${outlet}/`);
	},
	getOutletUsers(outlet, ...args) {
		return serverAddr.get(`/outlet/${outlet}/users/?fields=${args}`);
	},
	deleteUsers(params) {
		console.log(params);
		return serverAddr.post("/users/delete/", params);
	},
	getsDays() {
		return serverAddr.get(`/read/store-closed-dropdown/`);
	},
	getBusinessDays(params) {
		return serverAddr.post(`/read/business-days-day-part/`, params);
	},
	readAccountDetails(params) {
		return serverAddr.post(`/read/account-store-details/`, params);
	},
	addBusinessDays(id, params) {
		console.log(params);
		return serverAddr.post(
			`/add/update/business-days-day-part/?store=${id}`,
			params
		);
	},
	addStoreDetails(params) {
		console.log(params);
		return serverAddr.post(`create/update/account-store-details/`, params);
	}
};
